export default __webpack_public_path__ + "static/media/William.0a81864d.jpg";